import { createRecipe } from './runtime';

const textConfig = {"name":"text","variantMap":{"size":["2xl","3xl","4xl","5xl","6xl","7xl","lg","md","sm","xl","xs"],"variant":["heading"]}}

export const text = /* @__PURE__ */ createRecipe(textConfig)